// extracted by mini-css-extract-plugin
export var compactFilters = "_j5-4";
export var detailImage = "_j5-1";
export var dropdownContainer = "_j5-2";
export var imageContainer = "_j5-0";
export var selectedCard = "_j5-3";